import brand from '@helpers/brand';
import { Device, from } from '@helpers/media';
import styled, { css } from 'styled-components';
import SiteWide from '../SiteWide/SiteWide';
import DiagonalLinesRect from '@img/icons/diagonal-lines-rect.svg';
const StyledSection = styled(SiteWide) `
  background-color: ${brand.grey.grey96};
  border-top: 6px solid ${brand.primary.base};
  border-bottom: 6px solid ${brand.primary.base};
  padding: 26px 12px;

  @media ${from(Device.TabletLarge)} {
    padding: 56px 48px;
    margin-bottom: 50px;
    border-bottom: unset;

    ${({ showCorners }) => showCorners &&
    css `
        position: relative;
        margin-top: 30px;
        margin-bottom: 30px;
        border-bottom: 6px solid ${brand.primary.base};

        &:before {
          content: '';
          display: block;
          position: absolute;
          z-index: -1;
          bottom: -26px;
          left: -23px;
          width: 396px;
          height: 79px;
          background: url(${DiagonalLinesRect}) no-repeat center;
        }

        &:after {
          content: '';
          display: block;
          position: absolute;
          z-index: -1;
          top: -26px;
          right: -23px;
          width: 396px;
          height: 79px;
          background: url(${DiagonalLinesRect}) no-repeat center;
        }
      `}
  }
`;
export default {
    StyledSection,
};
